import React, { useState, useEffect } from 'react';
import { API } from '../../utils/api';

const CategoryTreePanel = ({ token, categories, onCategoryClick, selectedCategories }) => {
  const [expanded, setExpanded] = useState({});
  const [categoryCounts, setCategoryCounts] = useState({});

  useEffect(() => {
    if (!token || !categories || categories.length === 0) return;
    const x = new XMLHttpRequest();
    x.open('GET', `${API}/categories/counts`, true);
    x.setRequestHeader('Authorization', `Bearer ${token}`);
    x.onload = function () {
      if (x.status < 300) {
        try { setCategoryCounts(JSON.parse(x.responseText)); } catch (e) {}
      }
    };
    x.send();
  }, [token, categories]);

  const toggleExpand = (catId) => setExpanded(prev => ({ ...prev, [catId]: !prev[catId] }));

  // Group categories by protocol/parent
  const grouped = {};
  (categories || []).forEach(cat => {
    const parent = cat.protocol || cat.parent_name || 'Uncategorized';
    if (!grouped[parent]) grouped[parent] = [];
    grouped[parent].push(cat);
  });

  const isSelected = (id) => (selectedCategories || []).includes(id);

  return (
    <div data-testid="category-tree-panel" style={{
      background: 'linear-gradient(135deg, rgba(253, 251, 247,0.95), rgba(25,15,50,0.9))',
      borderRadius: 12, border: '1px solid rgba(253, 224, 71,0.2)',
      maxHeight: 340, overflowY: 'auto', padding: '10px 12px'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <span style={{ color: '#047857', fontSize: '0.7rem', fontWeight: 700, letterSpacing: 0.5, fontFamily: '"SF Mono", "Fira Code", monospace' }}>
          <i className="fas fa-sitemap" style={{ marginRight: 5 }} />CATEGORIES &amp; SUB-CATEGORIES
        </span>
        <span style={{ color: '#555', fontSize: '0.55rem' }}>{Object.keys(grouped).length} groups / {(categories || []).length} total</span>
      </div>

      {Object.entries(grouped).map(([parentName, cats]) => (
        <div key={parentName} style={{ marginBottom: 4 }}>
          {/* Parent/Protocol Header */}
          <div onClick={() => toggleExpand(parentName)}
            style={{ display: 'flex', alignItems: 'center', gap: 5, cursor: 'pointer', padding: '3px 6px', borderRadius: 6, background: expanded[parentName] ? 'rgba(253, 224, 71,0.08)' : 'transparent', transition: 'background 0.15s' }}
            data-testid={`cat-group-${parentName.replace(/\s+/g, '-').toLowerCase()}`}>
            <i className={`fas fa-${expanded[parentName] ? 'chevron-down' : 'chevron-right'}`}
              style={{ color: '#047857', fontSize: '0.5rem', width: 8 }} />
            <span style={{ color: '#c4b5fd', fontSize: '0.6rem', fontWeight: 700, fontFamily: '"SF Mono", monospace' }}>
              {parentName}
            </span>
            <span style={{ color: '#555', fontSize: '0.45rem', marginLeft: 'auto' }}>({cats.length})</span>
          </div>

          {/* Sub-categories */}
          {expanded[parentName] && cats.map(cat => {
            const sel = isSelected(cat._id || cat.id);
            const count = categoryCounts[cat._id || cat.id] || 0;
            return (
              <div key={cat._id || cat.id}
                onClick={() => onCategoryClick && onCategoryClick(cat._id || cat.id, cat.name)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 6,
                  padding: '2px 6px 2px 22px', cursor: 'pointer',
                  borderRadius: 4, transition: 'background 0.1s',
                  background: sel ? 'rgba(253, 230, 138,0.08)' : 'transparent'
                }}
                onMouseEnter={(e) => { if (!sel) e.currentTarget.style.background = 'rgba(255, 255, 255, 0.85)'; }}
                onMouseLeave={(e) => { if (!sel) e.currentTarget.style.background = 'transparent'; }}
                data-testid={`cat-item-${(cat._id || cat.id || '').toString().slice(-6)}`}
              >
                <div style={{
                  width: 8, height: 8, borderRadius: 2,
                  background: sel ? '#38bdf8' : 'rgba(203, 213, 225, 0.8)',
                  border: `1px solid ${sel ? '#38bdf8' : 'rgba(255,255,255,0.15)'}`,
                  flexShrink: 0, transition: 'all 0.15s'
                }} />
                <span style={{
                  color: sel ? '#38bdf8' : '#a1a1aa',
                  fontSize: '0.55rem', fontFamily: '"SF Mono", monospace',
                  fontWeight: sel ? 700 : 400, whiteSpace: 'nowrap',
                  overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 200
                }}>
                  {cat.name}
                </span>
                {count > 0 && (
                  <span style={{ color: '#555', fontSize: '0.4rem', marginLeft: 'auto', fontFamily: '"SF Mono", monospace' }}>
                    {count}
                  </span>
                )}
                {cat.is_public && (
                  <i className="fas fa-globe" style={{ color: 'rgba(16,185,129,0.4)', fontSize: '0.4rem' }} />
                )}
              </div>
            );
          })}
        </div>
      ))}

      {(!categories || categories.length === 0) && (
        <div style={{ color: '#555', fontSize: '0.6rem', textAlign: 'center', padding: 20 }}>
          No categories yet. Create or copy categories to see them here.
        </div>
      )}
    </div>
  );
};

export default CategoryTreePanel;
